import axios from 'axios';
import Endpoints from '../Endpoints';

export const listProducts = async (params = {}) => {
  const { data } = await axios.get(Endpoints.Products.LIST, { params });
  return data?.data || data;
};

export const uploadProductImages = async (files) => {
  const form = new FormData();
  const arr = Array.isArray(files) ? files : [files];
  arr.forEach(f => form.append('images', f));
  const { data } = await axios.post(Endpoints.Products.UPLOAD_IMAGES, form, {
    headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` }
  });
  return data?.data || data;
};

export const getProduct = async (id) => {
  const { data } = await axios.get(Endpoints.Products.SINGLE + id);
  return data?.data || data;
};

export const createProduct = async (payload) => {
  const { data } = await axios.post(Endpoints.Products.CREATE, payload);
  return data?.data || data;
};

export const updateProduct = async (id, payload) => {
  const { data } = await axios.put(Endpoints.Products.UPDATE + id, payload);
  return data?.data || data;
};

export const deleteProduct = async (id) => {
  const { data } = await axios.delete(Endpoints.Products.DELETE + id);
  return data?.data || data;
};
